export default function BoxingRingIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="44" width="56" height="14" rx="3" fill="#1F4FA8" />
      <path d="M4 18h56M4 28h56M4 38h56" stroke="#E8434F" strokeWidth="3" />
      <rect x="2" y="12" width="5" height="34" rx="2" fill="#C8CFD9" />
      <rect x="57" y="12" width="5" height="34" rx="2" fill="#C8CFD9" />
      <path d="M16 36 L22 46" stroke="#F2F2F2" strokeWidth="6" strokeLinecap="round" />
      <circle cx="18" cy="26" r="11" fill="#2F8BFF" stroke="#164787" strokeWidth="2" />
      <circle cx="14" cy="22" r="3" fill="#8CC6FF" />
      <path d="M48 36 L42 46" stroke="#F2F2F2" strokeWidth="6" strokeLinecap="round" />
      <circle cx="46" cy="26" r="11" fill="#FF8A1F" stroke="#8A4410" strokeWidth="2" />
      <circle cx="42" cy="22" r="3" fill="#FFC285" />
      <path d="M32 10 l3 7 7 1 -5 5 1 7 -6 -3 -6 3 1 -7 -5 -5 7 -1z" fill="#FFE36B" />
    </svg>
  );
}
